import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Cell,
  ResponsiveContainer,
  CartesianGrid,
  Tooltip,
} from "recharts";

const labelMap = {
  opportunity_fit: "Opportunity Fit",
  capability_match: "Capability Match",
  revenue_potential: "Revenue Potential",
  competitive_position: "Competitive Position",
  compliance_burden: "Compliance Burden",
  resource_demand: "Resource Demand",
  technical_complexity: "Technical Complexity",
  past_performance_alignment: "Past Performance",
  risk_profile: "Risk Profile",
  win_probability: "Win Probability",
};

function colorFor(v) {
  if (v >= 7) return "#10b981";
  if (v >= 4) return "#f59e0b";
  return "#ef4444";
}

export default function Scorecard({ scorecard }) {
  if (!scorecard) return null;
  const data = Object.keys(labelMap).map((k) => ({
    name: labelMap[k],
    value: Number(scorecard[k] || 0),
  }));

  return (
    <div className="bg-[var(--bg-secondary)] border border-[var(--border-soft)] p-5">
      <div className="flex items-baseline justify-between mb-4">
        <div className="tick-label text-sky-400">/ GovBidIQ Scorecard</div>
        <div className="text-right">
          <div className="tick-label">Overall</div>
          <div className="metric-number text-3xl text-sky-400">
            {scorecard.overall || 0}
            <span className="text-slate-500 text-sm">/100</span>
          </div>
        </div>
      </div>

      <div style={{ width: "100%", height: 320 }}>
        <ResponsiveContainer>
          <BarChart
            data={data}
            layout="vertical"
            margin={{ top: 5, right: 30, left: 0, bottom: 5 }}
          >
            <CartesianGrid stroke="#1f2a3d" strokeDasharray="0" horizontal={false} />
            <XAxis
              type="number"
              domain={[0, 10]}
              tick={{ fill: "#64748b", fontFamily: "IBM Plex Mono", fontSize: 10 }}
              stroke="#334155"
            />
            <YAxis
              type="category"
              dataKey="name"
              width={150}
              tick={{ fill: "#cbd5e1", fontFamily: "IBM Plex Sans", fontSize: 11 }}
              stroke="#334155"
            />
            <Tooltip
              cursor={{ fill: "rgba(14,165,233,0.05)" }}
              contentStyle={{
                backgroundColor: "#0a0f18",
                border: "1px solid #334155",
                borderRadius: 0,
                fontFamily: "IBM Plex Mono",
                fontSize: 11,
              }}
              labelStyle={{ color: "#94a3b8" }}
            />
            <Bar dataKey="value" radius={0}>
              {data.map((d, i) => (
                <Cell key={i} fill={colorFor(d.value)} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
